// extracted by mini-css-extract-plugin
module.exports = {"action":"action__CW2XO","ready":"ready__3rvvJ"};